module.exports = __webpack_public_path__ + "img/Attention.994be9d0.png";